import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';

import TPGrid from 'components/TP-UI/TPGrid';
import TPModal from 'components/TP-UI/TPModal';
import TPDivider from 'components/TP-UI/TPDivider';
import { ACCOUNT_PLANS } from 'constants/accountPlans';
import { selectAccountPlanRequest } from 'modules/accounts/pages/MyAccounts/actions';

import verificationModalNames from '../../constants/verificationModalNames';
import BenefitsSection from './components/BenefitsSection';
import config from 'config';

import useStyles from './styles';

const ProOrRetailModal = () => {
  const classes = useStyles();
  const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const dispatch = useDispatch();
  const { t } = useTranslation('quiz');

  const handleAccountPlanSelect = (accountPlan) => {
    dispatch(selectAccountPlanRequest(accountPlan));
  };

  return (
    <TPModal
      className={classes.modal}
      modalName={verificationModalNames.PRO_OR_RETAIL_MODAL}
      hideButtons
      title={t('proOrRetailModal.title')}>
      <TPGrid container direction="row" wrap={lgBreakpoint ? 'nowrap' : 'wrap'} spacing={3}>
        <TPGrid item container xs={12} lg={6}>
          <BenefitsSection
            accountPlan={ACCOUNT_PLANS.PRO}
            benefits={t(`proOrRetailModal.pro.benefits`, {
              returnObjects: true,
              brandLabel: config.CURRENT_SHORT_HUB_LABEL,
            })}
            buttonText={t(`proOrRetailModal.pro.selectAccountPlanButtonText`)}
            onAccountPlanSelect={handleAccountPlanSelect}
            title={t('proOrRetailModal.pro.title')}
          />
        </TPGrid>
        {lgBreakpoint && (
          <TPGrid item>
            <TPDivider orientation="vertical" />
          </TPGrid>
        )}
        <TPGrid item container xs={12} lg={6}>
          <BenefitsSection
            accountPlan={ACCOUNT_PLANS.RETAIL}
            benefits={t(`proOrRetailModal.retail.benefits`, { returnObjects: true })}
            buttonText={t(`proOrRetailModal.retail.selectAccountPlanButtonText`)}
            onAccountPlanSelect={handleAccountPlanSelect}
            title={t('proOrRetailModal.retail.title')}
          />
        </TPGrid>
      </TPGrid>
    </TPModal>
  );
};

export default ProOrRetailModal;
